import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getIPAddress } from 'actions/workflow';

export default function withIPAddress(WrappedComponent) {
  const HOC = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [ipAddress, setIpAddress] = useState(null);

    useEffect(() => {
      dispatch(getIPAddress({
        data: {},
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: () => {
          console.log('Getting IP address failed');
        },
      }));
    }, []);

    useEffect(() => {
      dispatch(getIPAddress({
        data: {},
        success: (ipResponse) => {
          setIpAddress(ipResponse.ip);
        },
        fail: () => {
          console.log('Getting IP address failed');
        },
      }));
    }, [location && location.pathname]);

    return <WrappedComponent {...props} ipAddress={ipAddress || 'Not able to detect IP Address!'} />;
  };

  return HOC;
}
